<template>
    <div class="bg-surface-background flex flex-col h-full px-safe pb-safe">
        <!-- Same row as in the report header, so switching workspace or signing in works here too -->
        <div class="pt-safe relative z-10">
            <div class="flex justify-end p-4 pb-0 sm:px-6 sm:pt-5">
                <AccountMenu class="min-w-0" />
            </div>
        </div>
        <div class="px-4 w-auto grow mx-auto flex flex-col gap-4 relative items-center justify-center">
            <div class="flex flex-row gap-3 items-center">
                <Icon type="api" class="w-10"></Icon>
                <div class="text-2xl">Whoops</div>
            </div>
            <div class="text-center">
                <div v-if="type === 'notFound'">We couldn't find this page</div>
                <div v-else-if="type === 'token'">This seems like an invalid url</div>
                <template v-else>
                    <div>Something went wrong here.</div>
                    <div>Please tap label again.</div>
                </template>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { Icon } from '@tapp.online/ui'
    import AccountMenu from '@/components/layout/AccountMenu.vue'

    defineProps<{ type?: string }>()
</script>
